import appConfig from "../shared/config/app-config";
import { fbIcon, InstaIcon, twitterIcon, youtubeIcon, linkedinIcon } from "./images";

export function subscriptionsField(subscription: string): string {
  let subscriptions: any = {
    weekly_vt_letter: 'Vet Times Weekly Newsletter',
    daily_vt_letter: 'Vet Times Daily Digest',
    monthly_vnt_letter: 'VN Times Monthly Newsletter',
    international_edition: 'International Edition',
    vbd_updates: 'VBD Updates',
    industry_updates: 'Industry Updates',
    digital_vettimes: 'Vet Times',
    digital_vntimes: 'VN Times',
    digital_vbj: 'VBJ',
    print_vettimes: 'Vet Times',
    print_vntimes: 'VN Times',
    print_vbj: 'VBJ',
    weekly_job_letter: "Weekly",
    monthly_advice: "Monthly",
    subscribe_to_vbd_offers: "Subscribe to VBD Offers",
    subscribe_to_third_party_info: "Subscribe to third party info",
    subscribe_to_workplace_panel: "Subscribe to workplace panel"
  };

  return subscriptions[subscription];
}

export const monthNames = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

// export function getCountryName(data: any) {
//   const countryName = data.country_name;
  
//   // Handle Taiwan variations (common in geolocation APIs)
//   if (countryName && countryName.toLowerCase().includes('taiwan')) {
//     return 'Taiwan';
//   }
  
//   switch (countryName) {
//     case 'United Kingdom of Great Britain and Northern Ireland':
//       return data.region_name
//     case 'United States of America':
//       return 'United States'
//     case 'Moldova (the Republic of)':
//       return 'Moldova, Republic Of'
//     case 'Bolivia (Plurinational State of)':
//       return 'Bolivia'
//     case 'Venezuela (Bolivarian Republic of)':
//       return 'Venezuela'
//     case 'North Macedonia':
//       return 'Macedonia, Former Yugoslav Republic Of'
//     default:
//       return countryName
//   }
// }

export const FOOTER_MENU = [
  {label: 'About', url: appConfig.vettimesUrl + 'about-us'},
  {label: 'Advertise with us', url: appConfig.vettimesUrl + 'advertising'},
  {label: 'Recruitment', url: appConfig.recruitersUrl},
  {label: 'Contact us', url: appConfig.vettimesUrl + 'contact-us'},
];

export const TERMS_AND_POLICIES = [
  {label: 'Terms and conditions', url: appConfig.vettimesUrl + 'terms-conditions'},
  {label: 'Complaints policy', url: appConfig.vettimesUrl + 'complaints-policy'},
  {label: 'Cookie policy', url: appConfig.vettimesUrl + 'cookie-policy'},
  {label: 'Privacy policy', url: appConfig.vettimesUrl + 'privacy-policy'},
];

export const SOCIAL_MEDIA_ICONS = [
  {icon: fbIcon, url: 'https://www.facebook.com/vettimesuk'},
  {icon: InstaIcon, url: 'https://www.instagram.com/vettimesuk/'},
  {icon: linkedinIcon, url: 'https://www.linkedin.com/showcase/10526832/admin/page-posts/published/'},
  {icon: twitterIcon, url: 'https://x.com/i/flow/login?redirect_after_login=%2Fvettimesuk'},
  {icon: youtubeIcon, url: 'https://www.youtube.com/@vettimes6701'},
];

export const JOB_ROLES = [
  {
    heading: 'Vets',
    data: [
      {
        value: 'C',
        label: 'Veterinary surgeon'
      },
      {
        value: 'S',
        label: 'Veterinary student'
      }
    ]
  },
  {
    heading: 'Nurse',
    data: [
      {
        value: 'D',
        label: 'Registered veterinary nurse'
      },
      {
        value: 'G',
        label: 'Student veterinary nurse'
      },
      {
        value: 'T',
        label: 'Veterinary technician'
      },
      {
        value: 'R',
        label: 'Veterinary nursing assistant'
      },
    ]
  },
  {
    heading: 'Non-clinical',
    data: [
      {
        value: 'P',
        label: 'Practice manager'
      },
      {
        value: 'H',
        label: 'Receptionist'
      },
      {
        value: 'O',
        label: 'Other'
      }
    ]
  }
];
